import ApiPermissions from '@/enums/ApiPermissions';

export default {
  namespaced: true,
  state: {
    permissions: [],
    loaded: false,
  },
  mutations: {
    setPermissions(state, permissions) {
      state.permissions = Array.isArray(permissions)
        ? permissions
        : ApiPermissions.memberValues;
      state.loaded = true;
    },
    resetPermissions(state) {
      state.permissions = [];
      state.loaded = false;
    },
  },
};
